
(function loginProviderDefinition() {

    'use strict';

    function roleAndCondition(left, right) {

        this.left = left;
        this.right = right;

        this.eval = function (auth, params) {
            return left.eval(auth, params) && right.eval(auth, params);
        };
    }

    function roleOrCondition(left, right) {

        this.left = left;
        this.right = right;

        this.eval = function (auth, params) {
            return left.eval(auth, params) || right.eval(auth, params);
        };
    }

    function roleNotCondition(cond) {

        this.cond = cond;

        this.eval = function (auth, params) {
            return !cond.eval(auth, params);
        };
    }
       

    function roleCondition(roles, paramsCondition) {

        if (!angular.isArray(roles) && typeof (roles) !== 'string') {
            throw "Roles invalidos.";
        }

        if (typeof (roles) === 'string') {
            roles = [roles];
        }

        this.roles = roles;

        if (paramsCondition == null) {
            this.testParams = function truthy() { return true; };
        } else {
            this.testParams = function (params) {

                angular.forEach(paramsCondition, function (condition, key) {
                    var value = params[key];
                    var result = true;
                    if (typeof condition === 'string') {
                        if (condition.length && condition.charAt(0) === '!') {
                            if (condition.length > 1 && condition.charAt(1) === '=')
                                result = (value + '') !== condition.substr(2);
                            else 
                                result = (value + '') != condition.substr(1);
                        } else {
                            if (condition.length && condition.charAt(0) === '=')
                                result = (value + '') === condition.substr(1);
                            else
                                result = (value + '') == condition.substr(0);
                        }
                    } else {
                        if (angular.isFunction(condition)) {
                            result = condition.call(params, key, value);
                        } else {
                            result = (value === condition);
                        }
                    }
                    if (!result)
                        return false;
                });
                return true;
            }
        }

        this.eval = function(auth, params) {
            for (var i = 0; i < this.roles.length; i++) {
                if (!auth.isInRole(this.roles[i])) {
                    return false;
                }
            }
            return this.testParams(params);
        };
    }

    function roleConditionBase() {

        this.and = function roleConditionAnd(roles, params) {
            if (roles.constructor !== 'RoleCondition') {
                roles = new roleCondition(roles, params);
            }
            return new roleAndCondition(this, roles);
        };

        this.or = function roleConditionOr(roles, params) {
            if (roles.constructor !== 'RoleCondition') {
                roles = new roleCondition(roles, params);
            }
            return new roleOrCondition(this, roles);
        };

        this.andNot = function (roles, params) {
            if (roles.constructor !== 'RoleCondition') {
                roles = new roleCondition(roles, params);
            }
            return new roleAndCondition(this, new roleNotCondition(roles));
        };

        this.orNot = function (roles, params) {
            if (roles.constructor !== 'RoleCondition') {
                roles = new roleCondition(roles, params);
            }
            return new roleOrCondition(this, new roleNotCondition(roles));
        };
    }

    roleAndCondition.prototype = new roleConditionBase();
    roleAndCondition.prototype.constructor = roleAndCondition;

    roleOrCondition.prototype = new roleConditionBase();
    roleOrCondition.prototype.constructor = roleOrCondition;

    roleNotCondition.prototype = new roleConditionBase();
    roleNotCondition.prototype.constructor = roleNotCondition;

    roleCondition.prototype = new roleConditionBase();
    roleCondition.prototype.constructor = roleCondition;

    angular.module('Login')
        .run([
            'auth', '$state', 'storage', '$rootScope', 'login', 'messages',
            function loginModuleRun(auth, $state, storage, $rootScope, login, messages) {

                function stateChanged(event, toState, toParams) {

                    if (toState.authorize === true || toState.roles != null) {

                        if (!auth.isLogged()) {

                            var params = angular.copy(toParams);

                            // si no está logueado, intento refrescar el token
                            auth.refreshToken()
                                .then(function(result) {
                                        if (result === true) {
                                            // redirecciono al destino
                                            $state.go(toState.name, params);
                                        } else {
                                            // tiene que loguearse
                                            storage.Session.store('loginRedirect', {
                                                state: toState.name,
                                                params: params
                                            });
                                            $state.go(login.loginState);
                                        }
                                    },
                                    function() {
                                        // tiene que loguearse
                                        storage.Session.store('loginRedirect', {
                                            state: toState.name,
                                            params: params
                                        });
                                        $state.go(login.loginState);
                                    });

                            // detengo el proceso de cambio de estado por el momento
                            event.preventDefault();
                            return true;
                        }

                        if (toState.roles != null) {

                            var roles = toState.roles;

                            if (roles.eval == null) {
                                roles = new roleCondition(roles);
                            }

                            if (!roles.eval(auth, toParams)) {

                                messages.show('UnauthorizedError')
                                    .then(function() {
                                        $state.go('inicio');
                                    });
                                return false;
                            }
                        }
                    }

                    return true;
                }

                $rootScope.$on('$stateChangeStart', stateChanged);
            }
        ])
        .provider('login', [
            'configProvider', 'authProvider', function loginProvider(config, authProvider) {

                var templatesUrl = config.resourceUrl('/components/login/');
                var changePasswordCallbackUrl = '';
				var applicationId = null;
                var imagesUrl = config.resourceUrl('/components/img/');
                var externalProvidersUrl = config.appUrl('/Home/Index');
                var externalProvidersUrlPopup = config.appUrl('/Home/External');

                var registerState = 'register';
                var confirmMailState = 'confirm-mail';
                var loggedState = 'inicio';
                var startState = 'inicio';
                var loginState = 'login';

                authProvider.onUnauthorized(['login', function loginUnauthorized(login) {
                    login.ensureLogged();
                }]);

                this.setRegisterState = function(state) {
                    registerState = state;
                    return this;
                };

                this.setStartState = function(state) {
                    startState = state;
                    return this;
                };

                this.setConfirmMailState = function(state) {
                    confirmMailState = state;
                    return this;
                };

                this.setLoggedState = function(state) {
                    loggedState = state;
                    return this;
                };

                this.setLoginState = function(state) {
                    loginState = state;
                    return this;
                };

                this.setTemplatesUrl = function(url) {
                    templatesUrl = url;
                };

                this.setImagesUrl = function(url) {
                    imagesUrl = url;
                    return this;
                };

                this.setChangePasswordCallbackUrl = function(url) {
                    changePasswordCallbackUrl = url;
                    return this;
                };

                this.setExternalProvidersUrl = function(url) {
                    externalProvidersUrl = url;
                    return this;
                };

                this.setExternalProvidersUrlPopup = function(url) {
                    externalProvidersUrlPopup = url;
                    return this;
                };
				
				this.setApplicationId = function (appId) {
                    applicationId = appId;
                };

                // Este método permitirá crear una condición de rol para un estado.
                // - El objeto retornado posee los siguientes metodos:
                //   and, or, andNot y orNot.
                //   Los métodos mencionados aceptan uno o mas roles o bien otra condicion.
                // - Si se pasa un arreglo, la condición se cumplirá si pertenece 
                //   a todos los roles del mismo.
                // - La evaluación es siempre agrupando por izquierda.
                this.roleCondition = function(roles) {
                    return new roleCondition(roles);
                };

                this.$get = [
                    'auth', '$state', '$stateParams', 'storage', '$rootScope', 'onMobile',
                    function(auth, $state, $stateParams, storage, $rootScope, mobile) {

                        function ensureLogged(state, params) {

                            state = state || $state.$current.self.name;
                            params = params || $stateParams; 

                            if (!auth.isLogged()) {

                                storage.Session.store('loginRedirect', {
                                    state: state,
                                    params: params
                                });
                                $state.go(loginState);

                            } else {

                                $state.go(state, params);

                            }
                        }

                        function redirect(result) {

                            if (result.action === 'register') {

                                $state.go(registerState);

                            } else if (result.action === 'confirm') {

                                $state.go(confirmMailState, { user: result.userId });

                            } else {

                                var loginRedirect = storage.Session.getItem('loginRedirect');

                                // redirecciono a la url de loginRedirect o a inicio
                                if (loginRedirect) {
                                    if ($state.get(loginRedirect.state)) {
                                        $state.go(loginRedirect.state, loginRedirect.params);
                                        storage.Session.remove('loginRedirect');
                                    }
                                } else {
                                    $state.go(startState);
                                }
                            }
                        }

                        $rootScope.$on('dynamic.loadFinished', function (event, hasRedirect) {
                            if (!hasRedirect)
                                redirect(true);
                        });

                        function logOut() {
                            var promise = auth.logout();

                            promise.then(function logOutSuccess() {
                                // lo redirecciono si el estado actual requiere usuario
                                var state = $state.$current;
                                do {
                                    if (state.self.authorize || state.self.roles || state.self.abstract) {
                                        $state.go(startState);
                                        return;
                                    } else {
                                        state = state.parent;
                                    }
                                } while (state !== undefined);
                            });

                            return promise;
                        }

                        function getExternalProvidersUrl(forAdd) {
                            if (forAdd) {
                                return addQueryParam((mobile) ? externalProvidersUrl : externalProvidersUrlPopup, "add", "true");
                            }
                            return (mobile) ? externalProvidersUrl : externalProvidersUrlPopup;
                        }

                        function loginWithProvider(provider) {
                            return auth.loginWithProvider(provider, null, !mobile);
                        }

                        function addLoginProvider(provider) {
                            return auth.addLoginProvider(provider, !mobile);
                        }

                        return {
                            logOut: logOut,
                            imagesUrl: imagesUrl,
                            templatesUrl: templatesUrl,
                            changePasswordCallbackUrl: changePasswordCallbackUrl,
                            externalProvidersUrl: externalProvidersUrl,
                            externalProvidersUrlPopup: externalProvidersUrlPopup,
                            loggedState: loggedState,
                            redirect: redirect,
                            ensureLogged: ensureLogged,
                            loginAndRedirect: ensureLogged,
                            loginState: loginState,
                            getExternalProvidersUrl: getExternalProvidersUrl,
                            loginWithProvider: loginWithProvider,
                            addLoginProvider: addLoginProvider,
                            applicationId:applicationId
                        };
                    }
                ];
            }
        ]);

})();